
<accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-users'></i> Información de Referencias
      </span>
      <button [hidden]="disabled" type="button" class="btn btn-outline-primary mb-4" (click)="addReference()"><i class="fa fa-address-book"></i>&nbsp;Agregar Referencia</button>
      <pos-table [data]="personReferenceTable" [pagination]="false" [headers]="getPersonalReferencesHeaders()" [disableHighlight]="true" highlightSuccessDangerField="status" ></pos-table>
      <div class="form-horizontal">
        <div class="row">
        </div>
        <div class="row col-12">
        </div>
    </div>
    </accordion-group>
    
</accordion>